import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** `#token=abc` -> `abc`; anything else -> null. */
export function tokenFromHash(hash: string): string | null {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const token = params.get('token');
  return token ? token : null;
}

/**
 * Read the one-time token the operator mails carry in the URL fragment
 * (`/verify-email#token=…`, `/reset-password#token=…`), then take it out of
 * the address bar so it is not left in history, a screenshot or a copied URL.
 *
 * The token is captured on first render and held in state, so clearing the
 * fragment does not lose it.
 */
export function useFragmentToken(): string | null {
  const location = useLocation();
  const navigate = useNavigate();
  const [token] = useState(() => tokenFromHash(location.hash));

  useEffect(() => {
    if (location.hash) {
      navigate({ pathname: location.pathname, search: location.search }, { replace: true });
    }
  }, [location.hash, location.pathname, location.search, navigate]);

  return token;
}
